import React from 'react'

import { Col, Grid } from '../../../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../../../packages/kiti/components/presentation/Text'
import PeriodDescription from '../../_shared/PeriodDescription'
import RankingLoader from './_load/RankingLoader'
import RankingTable from './RankingTable'
import Separator from '../../../../../packages/kiti/components/helpers/Separator'
import WidgetWrapper from '../../WidgetWrapper'

const RankingWidget = props => {
  const { widget } = props

  return (
    <WidgetWrapper {...props}>
      <Grid justify="space-between" gap={1}>
        <Col>
          <Title size="h5" noMargin>
            {widget.name}
          </Title>
          <PeriodDescription />
        </Col>
        <Col flex={1} />
      </Grid>

      <Separator weight={4} />
      <RankingLoader widget={widget}>
        <RankingTable />
      </RankingLoader>
    </WidgetWrapper>
  )
}

export default RankingWidget
